import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import {
  numberFormat,
  selectDropdownStyle,
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import { getAllPayrollReports } from "./../../../Helpers/apiCalls/Employees/PayrollApi";
import Footer from "../../../Components/Footer/Footer";

export default function PayrollReport() {
  const [inactive, setInactive] = useState(true);
  const [filterConfig, setFilterConfig] = useState({
    // branch_id: "8",
    // date_from: dateToday,
    // date_to: dateToday,
  });
  const [employees, setEmployees] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [allData, setAllData] = useState([]);

  async function fetchEmployees() {
    const response = await getAllEmployees();
    if (response.error) {
      setEmployees([]);
    } else {
      let result = response.data.data.map((data) => {
        var employee = data;
        employee.label = data.first_name + " " + data.last_name;
        employee.value = data.id;
        return employee;
      });
      setEmployees([{ label: "All Employees", value: "" }, ...result]);
    }
  }

  async function fetchData() {
    setShowLoader(true);
    setAllData([]);

    const response = await getAllPayrollReports(filterConfig);

    if (response.error) {
    } else {
      var allBills = response.data.data.map((bill) => {
        var info = bill;
        info.payroll_range =
          Moment(bill.date_from).format("MMM DD, YYYY") +
          " to " +
          Moment(bill.date_to).format("MMM DD, YYYY");
        info.order_date = Moment(bill.added_on).format("MM-DD-YYYY");
        info.usage_qty = numberFormat(bill.usage_qty);
        info.other_wages_remarks =
          parseInt(bill.other_wages) !== 0
            ? numberFormat(bill.other_wages) +
              " - " +
              bill.other_wages_description
            : "";
        info.other_deduction_remarks =
          parseInt(bill.other_deductions) !== 0
            ? numberFormat(bill.other_deductions) +
              " - " +
              bill.other_deductions_description
            : "";
        return info;
      });

      setAllData(allBills);
    }
    setShowLoader(false);
  }

  React.useEffect(() => {
    fetchEmployees();
  }, []);

  React.useEffect(() => {
    fetchData();
  }, [filterConfig]);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"HR REPORTS"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={6}>
            <h1 className="page-title"> PAYROLL REPORT </h1>
          </Col>
        </Row>

        <div className="tab-content">
          {/* filters */}
          <div className="my-2 px-2 PO-filters d-flex">
            <span className="me-4 align-middle mt-2 ps-label">Filter By:</span>
            <Select
              className="dropsearch-filter px-0 py-0 me-2"
              classNamePrefix="react-select"
              placeholder="Select Employee"
              styles={selectDropdownStyle}
              options={employees}
              onChange={(e) => {
                setFilterConfig((prev) => {
                  return { ...prev, employee_id: e.value };
                });
              }}
            />

            <span className="me-4 align-middle mt-2 ps-label">From:</span>
            <DatePicker
              autoComplete="off"
              selected={filterConfig.date_from}
              name="date_from"
              placeholderText={"Select Date"}
              onChange={(date) => {
                setFilterConfig((prev) => {
                  return { ...prev, date_from: date };
                });
              }}
              fixedHeight
              className="PI-date-btn me-3 form-control"
              showYearDropdown
              dateFormatCalendar="MMMM"
              yearDropdownItemNumber={20}
              scrollableYearDropdown
            />

            <span className="me-4 align-middle mt-2 ps-label">To:</span>
            <DatePicker
              autoComplete="off"
              selected={filterConfig.date_to}
              name="date_to"
              placeholderText={"Select Date"}
              onChange={(date) => {
                setFilterConfig((prev) => {
                  return { ...prev, date_to: date };
                });
              }}
              fixedHeight
              className="PI-date-btn me-3 form-control"
              showYearDropdown
              dateFormatCalendar="MMMM"
              yearDropdownItemNumber={20}
              scrollableYearDropdown
            />
          </div>

          <div className="below">
            <Table
              tableHeaders={[
                // "-",
                "PAYROLL RANGE",
                "EMPLOYEE NAME",
                "DISBURSEMENT DATE",
                "TYPE",
                "OTHER WAGES",
                "OTHER DEDUCTIONS",
                // "ACTIONS",
              ]}
              headerSelector={[
                // "-",
                "payroll_range",
                "employee_name",
                "disbursement_date",
                "disbursement_type",
                "other_wages_remarks",
                "other_deduction_remarks",
              ]}
              tableData={allData}
              showLoader={showLoader}
            />
          </div>
          <div className="mb-2" />
        </div>
      </div>
      <Footer/>
    </div>
  );
}
